const hostApi = process.env.VUE_APP_URL_API_HOST;
const portApi = process.env.VUE_APP_URL_API_PORT;
const baseURLApi = `${hostApi}${portApi ? `:${portApi}` : ``}/api`;
// const baseURLApi = `http://localhost:3000/api`;
const redirectUrl = process.env.NODE_ENV === "development" ? "http://front.ais24.local" : "https://demo.flatlogic.com/vue-material";
const isDevMode = process.env.NODE_ENV === "development";

export default {
  light: {
    primary: "#536dfe",
    primaryConst: "#536dfe",
    secondary: "#FF5C93",
    secondaryConst: "#FF5C93",
    error: "#ff5252",
    warning: "#FFC260",
    success: "#3CD4A0",
    successConst: "#3CD4A0",
    info: "#2196f3",
    greyBold: '#4a4a4a',
    greyBoldConst: '#4a4a4a',
    greyMedium: '#6e6e6e',
    greyTint: '#b9b9b9',
    default: '#e0e0e0',
    iconColor: "#FFFFFF59"
  },
  dark: {
    primary: "#536dfe",
    primaryConst: "#536dfe",
    secondary: "#FF5C93",
    secondaryConst: "#FF5C93",
    success: "#3CD4A0",
    successConst: "#3CD4A0",
    error: "#FF4081",
    greyMedium: '#bfbfbf',
    greyBold: '#d6d6d6',
    greyBoldConst: '#4a4a4a',
    greyTint: '#9b9b9b',
    default: '#e0e0e0',
  },
  hostApi,
  portApi,
  baseURLApi,
  redirectUrl,
  isDevMode,
  isBackend: process.env.VUE_APP_BACKEND,
  remote: "https://sing-generator-node.herokuapp.com",
  auth: {
    email: 'admin@ais24.ru',
    password: '12345678'
  }
};


